(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    function closeMenuDrawer() {
      const details = document.getElementById('Details-menu-drawer-container');
      if (details) details.open = false;
    }

    function fireClick(el) {
      el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    }

    document.querySelector('.mobile-nav__search-btn')?.addEventListener('click', () => {
      closeMenuDrawer();
      setTimeout(() => {
        const btn = [...document.querySelectorAll('[aria-label="Search"]')]
          .find(el => !el.closest('.custom-cart-drawer-wrapper'));
        if (btn) fireClick(btn);
      }, 300);
    });

    document.querySelector('.mobile-nav__cart-btn')?.addEventListener('click', () => {
      const cartToggle = document.querySelector('.header-actions__action.action__cart');
      if (cartToggle) fireClick(cartToggle);
      setTimeout(closeMenuDrawer, 50);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
